var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"title"},[_c('font-awesome-icon',{staticClass:"font-awesome-icon order-details-delivery-date",attrs:{"icon":"check"}}),_vm._v("\n    Geleverd: "+_vm._s(_vm._f("deliveryDate")(_vm.orderDetails.deliveryDate))+"\n  ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }